"use client";
import { usePathWithParams } from "@/hooks";
import Link from "next/link";
import { memo } from "react";

type LinkWithParamsProps = React.ComponentProps<typeof Link> & {
  children: React.ReactNode;
};

export const LinkWithParams = memo(({ children, href, ...props }: LinkWithParamsProps) => {
  const pathWithParams = usePathWithParams();
  return (
    <Link href={pathWithParams(href as string)} {...props} aria-label={children?.toString() || ""}>
      {children}
    </Link>
  );
});

LinkWithParams.displayName = "LinkWithParams";
